import React, { Component } from "react";
import ApiConnect from "../../../Util/ApiConnect";

export default class KotBill extends Component {
  constructor(props) {
    super(props);
    const paramsData = props.match.params;
    this.state = {
      CompanyData: [],
      OrdersData: [],
      kot: paramsData.billno,
      company: paramsData.company,
      id: paramsData.id,
    };
  }
  componentDidMount() {
    this.fetchKotInfo();
  }
  fetchKotInfo() {
    ApiConnect.get(
      `/CustomerQR/KotBill?company=${this.state.company}&id=${this.state.id}&kotno=${this.state.kot}`
    ).then((response) => {
      this.setState({
        CompanyData: response.data.company,
        OrdersData: response.data.order,
      }).catch((error) => console.log(error));
    });
  }
  render() {
    const Company = this.state.CompanyData;
    const CurrentCart = this.state.OrdersData;
    const OrdersList = this.state.OrdersData.particular || [];
    console.log(this.state);
    return (
      <div className="container mt-3 mb-3">
        <header className="text-center">
          <label className="company-name">{Company.name}</label>
          <br />
          {Company.address}
          <br />
          {Company.contact ? `Tel: ${Company.contact}` : ""}
          <br />
          {Company.mail ? `Email: ${Company.mail}` : ""}
          <br />
          {Company.tagline ? `${Company.tagline}` : ""}
          <br />
          <table style={{ width: "100%", paddingTop: "5px" }}>
            <tbody>
              <tr>
                <td>Order ID:</td>
                <td className="text-right">{CurrentCart.id}</td>
              </tr>
              <tr>
                <td>Date:</td>
                <td className="text-right">
                  {CurrentCart.date}
                  <small> {CurrentCart.miti}</small>
                </td>
              </tr>
            </tbody>
          </table>
        </header>
        <div className="main-body">
          <div className="info-item-list">
            <table style={{ width: "100%" }}>
              <thead>
                <th>
                  <strong>
                    Description(
                    {OrdersList.length === 1
                      ? `${OrdersList.length} Item`
                      : `${OrdersList.length} Items`}
                    )
                  </strong>
                </th>
                <th>
                  <strong>Qty</strong>
                </th>
                <th>
                  <strong>Rate</strong>
                </th>
                <th>
                  <strong>Amt</strong>
                </th>
              </thead>
              <tbody>
                {OrdersList
                  ? OrdersList.map((order, index) => (
                      <tr key={index}>
                        <td> {order.product}</td>
                        <td className="text-right"> {order.qty} </td>
                        <td className="text-right">{order.rate}</td>
                        <td className="text-right">{order.qty * order.rate}</td>
                      </tr>
                    ))
                  : ""}
              </tbody>
            </table>
            <hr />
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td className="pad-l-5">Total</td>
                  <td className="text-right" colSpan={3}>
                    {CurrentCart ? CurrentCart.subtotal : 0}/-
                  </td>
                </tr>
                <tr>
                  <td className="pad-l-5">
                    Discount{" "}
                    <small>
                      {CurrentCart ? CurrentCart.discoint_percentage : 0}%
                    </small>
                  </td>
                  <td className="text-right" colSpan={2}>
                    {CurrentCart ? CurrentCart.discount_amount : 0}
                    /-
                  </td>
                </tr>
                <tr>
                  <td className="pad-l-5">
                    Service Charge{" "}
                    <small>
                      {CurrentCart ? CurrentCart.service_charge : 0}%
                    </small>
                  </td>
                  <td className="text-right" colSpan={2}>
                    {CurrentCart ? CurrentCart.service_amount : ""}/-
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Grand Total</strong>
                  </td>
                  <td className="text-right">
                    <strong>{CurrentCart ? CurrentCart.total : 0}/-</strong>
                  </td>
                </tr>
                <tr>
                  <td>Payment Type</td>
                  <td className="text-right">
                    {CurrentCart ? CurrentCart.payment : "false"}
                  </td>
                </tr>
                <tr className="text-center">{CurrentCart.inword}</tr>
              </tbody>
            </table>
          </div>
          <hr />
          {/*   End of Vat Table   */}
          <footer className="info-client">
            <div className="info-graditude-text text-center border-bottom">
              <p className="text-center">
                <small>
                  This invoice is not considered as original. Please receive
                  original one after.
                </small>
                <small>
                  <br />
                  {Company.Website ? `${Company.Website}` : ""}
                </small>
              </p>
            </div>
          </footer>
        </div>
      </div>
    );
  }
}
